import { GenericLabPreferenceCampaign, LaboratorioOption } from '../../interfaces/medicine';
import { MedicineService } from '../../components/search/medicineService';

const sponsoredByPrescription = new Map<number, Map<number, number>>();
const laboratoriesByMedicine = new Map<number, LaboratorioOption[]>();

function buildSponsoredMap(campaigns: GenericLabPreferenceCampaign[]): Map<number, number> {
  const sponsored = new Map<number, number>();

  campaigns.forEach((campaign) => {
    campaign.products?.forEach((product) => {
      const preference = product.genericLabPreference;
      if (preference?.active) {
        sponsored.set(preference.medicineId, preference.laboratoryId);
      }
    });
  });

  return sponsored;
}

async function getSponsoredMap(prescriptionId: number, doctorId: number, partnerId?: number) {
  const cached = sponsoredByPrescription.get(prescriptionId);
  if (cached) return cached;

  const campaigns = await MedicineService.getGenericLabPreferences(prescriptionId, doctorId, partnerId);
  if (campaigns == null) return new Map<number, number>();

  const sponsored = buildSponsoredMap(campaigns);
  sponsoredByPrescription.set(prescriptionId, sponsored);
  return sponsored;
}

async function getLaboratories(medicineId: number, prescriptionId: number) {
  const cached = laboratoriesByMedicine.get(medicineId);
  if (cached) return cached;

  const laboratories = await MedicineService.getMedicineLaboratories(medicineId, prescriptionId);
  if (laboratories == null) return [];

  laboratoriesByMedicine.set(medicineId, laboratories);
  return laboratories;
}

export interface GenericLabInfo {
  laboratorios: LaboratorioOption[];
  idLaboratorioPatrocinado: number | null;
}

export async function resolveGenericLabInfo(params: {
  medicineId: number;
  prescriptionId: number;
  doctorId: number;
  partnerId?: number;
}): Promise<GenericLabInfo> {
  const { medicineId, prescriptionId, doctorId, partnerId } = params;

  const [laboratorios, sponsored] = await Promise.all([
    getLaboratories(medicineId, prescriptionId),
    getSponsoredMap(prescriptionId, doctorId, partnerId),
  ]);

  return {
    laboratorios,
    idLaboratorioPatrocinado: sponsored.get(medicineId) ?? null,
  };
}
